<template>
  <div class="contactInfoMain" :style="cssProps" v-if="contact">
    <div class="topBar">
      <img class="closeBtn" src="@/assets/images/close4.png" @click="closeRightColumn" alt="">
      <div class="barTitle">
        Kişi Bilgisi
      </div>
    </div>
    <div class="mainInfoDiv">
      <img :src="imageData" class="contactImage">
    </div>

    <div class="contactDescriptionDiv" v-if="contact.contactDescription !== ''">
      <div class="contactTitleCont">
        <div class="infoRow">
          <div class="contentText">
            {{ contact.VisibleName }}
          </div>
        </div>
      </div>

      <div class="infoRow">
        <div class="headerText">
          Durum
        </div>
        <div class="contentText">
          {{ statusText }}
        </div>
      </div>

      <div class="infoRow">
        <div class="headerText">
          Unvan
        </div>
        <div class="contentText">
          {{ titleText }}
        </div>
      </div>

      <div class="infoRow">
        <div class="headerText">
          Bölüm
        </div>
        <div class="contentText">
          {{ departmentText }}
        </div>
      </div>

      <div class="infoRow">
        <div class="headerText">
          Email
        </div>
        <div class="contentText">
          {{ emailText }}
        </div>
      </div>

      <div class="infoRow">
        <div class="headerText">
          Telefon
        </div>
        <div class="contentText">
          {{ mobileText }}
        </div>
      </div>

      <div class="infoRow">
        <div class="headerText">
          Dahili
        </div>
        <div class="contentText">
          {{ internalText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  messageMixin
} from '@/mixins/messageMixin.js'
export default {
  mixins: [messageMixin],
  data () {
    return {
      imageData: ''
    }
  },
  methods: {
    closeRightColumn () {
      this.$store.state.display.rightSideColumn.isExpanded = false
    },
    image () {
      var vm = this
      return new Promise(function (resolve, reject) {
        if (vm.contact.PhotoURL.includes('http')) {
          resolve(vm.makeBlob(vm.contact.PhotoURL, vm.contact.PhotoURL))
        } else {
          let key = '6a61e395-b49a-4468-bee0-27644e95308f'
          var iv = key.split('').reverse().join('')
          let encryptedBody = vm.ewk(vm.contact.PhotoURL, key, iv)
          resolve(vm.makeBlob(vm.serviceUrl + '/gfe?fn=' + vm.contact.PhotoURL + '&s=' + encodeURIComponent(encryptedBody), vm.contact.PhotoURL))
        }
      })
    }
  },
  watch: {
    activeConversation: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.image().then((value) => {
          this.imageData = value
        })
      }
    }
  },
  mounted () {},
  computed: {
    activeConversation () {
      this.$store.state.conversation.activeConversation
    },
    contact () {
      return this.$store.state.contacts.find(c => c.UserID === this.$store.state.conversation.activeConversation
        .ContactID)
    },

    cssProps () {
      return {
        '--mainThemeColor': this.$config.theme.default.common.coloredTextColor
      }
    },

    photoURL () {
      let photoURL = this.contact.PhotoURL
      if (!photoURL || photoURL === '') {
        photoURL = '/images/nophoto.png'
      }
      return photoURL
    },

    statusText () {
      return this.contact.StatusText ? this.contact.StatusText : '-'
    },

    titleText () {
      return this.contact.Title ? this.contact.Title : '-'
    },

    departmentText () {
      return this.contact.Department ? this.contact.Department : '-'
    },

    emailText () {
      return this.contact.Email ? this.contact.Email : '-'
    },

    mobileText () {
      return this.contact.MobilePhone ? this.contact.MobilePhone : '-'
    },

    internalText () {
      return this.contact.InternalPhone ? this.contact.InternalPhone : '-'
    }
  }
}

</script>

<style lang="less" scoped>
  @border-color: rgb(223, 223, 223);
  @bg-color: rgb(243, 243, 243);

  .contactInfoMain {
    background-color: @bg-color;
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100% - 0px);
    border-left: 1px solid @border-color;
    border-right: $border-left;
  }

  .infoBox {
    border-bottom: 1px solid @border-color;
    padding-bottom: 10px;
    background-color: white;
    box-shadow: 10px 10px 10px -16px rgba(0, 0, 0, 0.75);
  }

  .topBar {
    background-color: #eaeceb;
    height: 60px;
    display: flex;
    align-items: center;
    flex-grow: 0;
    flex-shrink: 0;
    border-bottom: @border-color 1px solid;
    border-left: @border-color 1px solid;

  }

  .closeBtn {
    width: 15px;
    height: 15px;
    margin-left: 15px;
    cursor: pointer;
  }

  .barTitle {
    margin-left: 20px;
    font-size: 16px;
  }

  .mainInfoDiv {
    .infoBox;
    text-align: center;
  }

  .contactDescriptionDiv {
    margin-top: 20px;
    min-height: 40px;
    padding-top: 1px;
    .infoBox;

    &>div {
      margin: 10px;
    }
  }

  .infoRow {
    display: flex;
    flex-direction: row;
    justify-content: space-between
  }

  .headerText {
    color: var(--mainThemeColor);
  }

  .contentText {}

  .contactImage {
    margin: auto;
    width: 220px;
    height: 220px;
    margin-top: 20px;
    border-radius: 110px;
    object-fit: cover;
  }

  .contactTitleCont {
    display: flex;
    align-items: center;
    margin: 10px;
    margin-bottom: 5px;
    text-align: left;

    &>.editable {
      border-bottom: 1px solid @border-color
    }

    &>div {
      flex-grow: 1;
      border-bottom: 1px solid rgba(0, 0, 0, 0);
    }

    &>img {
      width: 15px;
      height: 15px;
      flex-grow: 0;
      margin-right: 10px;
      cursor: pointer;
    }
  }

  .contactTitle:focus {
    outline: none;
  }

  .createDate {
    color: rgb(165, 165, 165);
    font-size: 13px;
    text-align: left;
    margin-left: 10px;
  }

  .participantRow {
    display: flex;
    align-items: center;
    font-size: 14px;

    &>img:first-child {
      width: 30px;
      height: 30px;
      border-radius: 15px;
      margin-right: 10px;
    }

    &>.participantName {
      flex-grow: 1;
    }

    &>.contactAdmin {
      font-size: 11px;
      padding: 2px;
      padding-left: 3px;
      padding-right: 3px;
      border: 1px solid var(--mainThemeColor);
      border-radius: 4px;
      font-weight: 700;
      color: var(--mainThemeColor);
    }
  }

  .leavecontactDiv {
    margin-top: 20px;
    padding: 10px;
    .infoBox;

    &>.leavecontactLink {
      color: red;
      cursor: pointer;

    }

  }

  .contactInfoMain::-webkit-scrollbar {
    width: 2px;
  }

  .contactInfoMain::-webkit-scrollbar-thumb {
    background-color: rgb(155, 155, 155);
  }

</style>
